export enum HighRiskType {
    BEHAVIORAL = "BEHAVIORAL",
    PAIN = "PAIN",
    BEHAVIORAL_AND_PAIN = "BEHAVIORAL_AND_PAIN",
}
